module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_JPWxNHL_Group.64781bac.jpg";